import SettingValues from './SettingValues';

export default SettingValues;